import { PreInterviewNotificationSendingMode } from '@dreryk/egabinet-patient-portal-frontend-api';

export const SENDING_MODES: PreInterviewNotificationSendingMode[] = ['ON_APPOINTMENT_CREATED', 'MANUAL'];
export type SendingMode = PreInterviewNotificationSendingMode;

export type SendingModeFieldFormBeanPart = { preInterviewSendingMode: SendingMode };
